import { addDoc, collection, getDocs, limit, orderBy, query, Timestamp, where, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { PLAN_TYPES, DEFAULT_PLAN } from './constants';

const plansCol = (uid) => collection(db, 'users', uid, 'plans');

const LIMITS = {
  [PLAN_TYPES.FREE]: { maxCalendars: 1, maxMembersPerCalendar: 3 },
  [PLAN_TYPES.BASIC]: { maxCalendars: Infinity, maxMembersPerCalendar: 10 },
  [PLAN_TYPES.PRO]: { maxCalendars: Infinity, maxMembersPerCalendar: Infinity },
  [PLAN_TYPES.ENTERPRISE]: { maxCalendars: Infinity, maxMembersPerCalendar: Infinity },
};

export const PlanService = {
  async ensureDefaultFreePlan(uid) {
    if (!uid) return false;
    // If user already has at least one plan doc, do nothing
    const snap = await getDocs(query(plansCol(uid), limit(1)));
    if (!snap.empty) return false;
    const now = new Date();
    await addDoc(plansCol(uid), {
      type: PLAN_TYPES.FREE,
      effectiveDate: Timestamp.fromDate(now),
      createdAt: Timestamp.fromDate(now),
    });
    return true;
  },

  async getCurrentPlan(uid, at = new Date()) {
    if (!uid) return DEFAULT_PLAN;
    const snap = await getDocs(
      query(
        plansCol(uid),
        where('effectiveDate', '<=', Timestamp.fromDate(at)),
        orderBy('effectiveDate', 'desc'),
        limit(1)
      )
    );
    if (snap.empty) return DEFAULT_PLAN;
    const d = snap.docs[0].data();
    return d?.type || DEFAULT_PLAN;
  },

  async schedulePlanChange(uid, type, effectiveFrom = null) {
    if (!uid) return null;
    const now = new Date();
    // Default: first day of next month 00:00
    let eff = effectiveFrom ? new Date(effectiveFrom) : null;
    if (!eff || isNaN(eff.getTime())) {
      const y = now.getFullYear();
      const m = now.getMonth();
      eff = new Date(y, m + 1, 1, 0, 0, 0, 0);
    }
    const ref = await addDoc(plansCol(uid), {
      type,
      effectiveDate: Timestamp.fromDate(eff),
      createdAt: Timestamp.fromDate(now),
    });
    return { id: ref.id };
  },

  async listScheduledPlans(uid, after = new Date()) {
    if (!uid) return [];
    const snap = await getDocs(
      query(
        plansCol(uid),
        where('effectiveDate', '>', Timestamp.fromDate(after)),
        orderBy('effectiveDate', 'asc')
      )
    );
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  async cancelScheduledPlan(uid, planId) {
    if (!uid || !planId) return false;
    try {
      await deleteDoc(doc(db, 'users', uid, 'plans', planId));
      return true;
    } catch {
      return false;
    }
  },

  getLimits(planType) {
    return LIMITS[planType] || LIMITS[PLAN_TYPES.FREE];
  },
};
